import {MdDashboard, MdOutlineDocumentScanner,MdPerson,MdOutlineReceiptLong, MdSettings, MdPeople, MdLocationOn, MdOutlineInput,MdOutlineOutput,MdListAlt,MdLibraryBooks} from 'react-icons/md';
import { TbMeat } from "react-icons/tb";
import { ImEarth } from "react-icons/im";
import {GiCow} from "react-icons/gi";
import {RiDeleteBack2Line} from "react-icons/ri"
import {AiOutlineDatabase} from "react-icons/ai"



const GruntComponents={
    DashBoard:{code:'dash',caption:'Nadzorna ploča', ico:<MdDashboard/>},
    Operateri:{code:'oper',caption:'Operateri', ico:<MdPerson/>},
    Knjige:{code:'knjg',caption:'Knjige', ico:<MdLibraryBooks/>},
    Postavke:{code:'settings',caption:'Postavke',ico:<MdSettings/>},
    Osobe:{code:'osobe',caption:'Partneri', ico:<MdPeople/>},
    Klaonice:{code:'klaonice',caption:'Klaonice', ico:<TbMeat/>},
    Drzave:{code:'drzave',caption:'Države', ico:<ImEarth/>},
    Lokacije:{code:'lokacije',caption:'Lokacije', ico:<MdLocationOn/>},
    Pasmine:{code:'pasmine',caption:'Pasmine', ico:<GiCow/>},
    Registar:{code:'registar',caption:'Registar', ico:<AiOutlineDatabase/>},
    Dolasci:{code:'dolasci',caption:'Dolasci', ico:<MdOutlineInput/>},
    Odlasci:{code:'odlasci',caption:'Odlasci', ico:<MdOutlineOutput/>},
    Izlucenja:{code:'izlucenja',caption:'Izlučenja', ico:<RiDeleteBack2Line/>},
    PopisGoveda:{code:'popisi',caption:"Radni popisi goveda",ico:<MdOutlineReceiptLong/>},
    PopisGovedaDetail:{code:'popisgovdetail',caption:"Goveda",ico:<MdOutlineReceiptLong/>},
    Specifikacije:{code:'specifikacije',caption:'Specifikacije odlazaka', ico:<MdListAlt/>},
    SkeniranjePutnihListova:{code:'govscan',caption:'Očitavanje putnih listova', ico:<MdOutlineDocumentScanner/>}
    
}



export default GruntComponents;

